import styled from 'styled-components/macro';
import OuterBox from 'Common/components/Boxes/OuterBox';

const Tile = styled(OuterBox)`
    width: 100%;
    padding: 20px;
`;

export default Tile;
